function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var reactSelectStyle = {
  control: function control(provided, state) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      border: '1px solid #cccfd2',
      borderCollapse: 'separate',
      borderRadius: '0',
      cursor: 'default',
      fontSize: '16px',
      fontWeight: '400',
      borderColor: state.isFocused ? '#027e6f' : '#cccfd2',
      boxShadow: state.isFocused ? '0 0 0 1px #027e6f' : 'none',
      '&:hover': {
        borderColor: '#027e6f'
      }
    });
  },
  valueContainer: function valueContainer(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      height: '2.3rem',
      padding: '0 8px',
      position: 'static'
    });
  },
  dropdownIndicator: function dropdownIndicator(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      color: '#027e6f',
      '&:hover': {
        color: '#027e6f'
      }
    });
  },
  indicatorsContainer: function indicatorsContainer(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      height: '2.3rem',
      padding: '0 0.05rem'
    });
  },
  indicatorSeparator: function indicatorSeparator(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      display: 'none'
    });
  },
  option: function option(provided, state) {
    var backgroundColor = 'white';
    var color = 'black';
    if (state.isSelected) {
      backgroundColor = '#027e6f';
      color = 'white';
    } else if (state.isFocused) {
      backgroundColor = '#e6f4f2';
    }
    return _objectSpread(_objectSpread({}, provided), {}, {
      backgroundColor: backgroundColor,
      color: color
    });
  },
  menu: function menu(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      border: '1px solid #cccfd2'
    });
  }
};
export default reactSelectStyle;